import http from '../Http';
import { useContext, useState, useRef, useEffect } from 'react';
import utils from '../utils';
import { Modal, Button, Input, Form, Select, Switch } from 'antd';
import InputPrefix from '../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

function DistributorUserModifier (props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const {show, onClose, row} = props;

    const [form] = Form.useForm();

    const [distributorSelectOptions, setDistributorSelectOptions] = useState([]);

    const [params, setParams] = useState({});
    
    const refTimerDistributorSearcher = useRef(null);
    const refDistributorSearchValue = useRef(null);

    const [timezoneSelectOptions, setTimezoneSelectOptions] = useState([]);
    const refTimerTimezoneSearcher = useRef(null);
    const refTimezoneSearchValue = useRef(null);

    useEffect(() => {
        if (!row) {
            return;
        }

        let active = true;
        console.log("DistributorUserModifier Effect");

        (async () => {
            let resp = await http.post("user/management/distributor-user/detail/get", {
                UserID: encodeURIComponent(row.ID),
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                console.log("[UserManagement]", e);
                return null;
            });

            if (! active) {
                return;
            }
            
            if (resp === null || resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load data error")});
                
                setParams({});
        
                return;
            }
            if (resp.data && resp.data.length > 0) {
                const ps = resp.data[0];

                ps._DistributorID = ps.DistributorID
                ps.DistributorID = ps.DistributorName
                
                setParams(ps);
                form.setFieldsValue(ps);
            }
            
        })();

        return () => {
            active = false;
            console.log("UserManagement Effect Cancel");
        };
    }, [row]);

    const handleCancle = () => {
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => {return null});
        
        if (ps === null) {
            return;
        }

        ps.CreateTime = row.CreateTime;
        ps.Enabled = ps.Enabled ? 1 : 0;
        ps.Name = encodeURIComponent(ps.Name || "");
        ps.Phone = encodeURIComponent(ps.Phone || "");
        ps.EMail = encodeURIComponent(ps.EMail || "");
        ps.Address = encodeURIComponent(ps.Address || "");
        
        if (ps.DistributorID === params.DistributorID) {
            ps.DistributorID = params._DistributorID
        }

        const resp = await http.post("user/management/distributor-user/modify", ps).then(async (r)=>{
            return await r.json();
        }).catch((e) => {
            console.log("[DistributorUserModifier]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("modify error")});
                return
            }

            setTip({open: true, severity: 'success', msg: t('modify success')});

            ps.DistributorName = (resp.data.DistributorName || "");
            ps.GmtOffset = resp.data.GmtOffset;

            onClose({...params, ...ps});
        } catch (e) {
            console.log("[DistributorUserModifier]", e);

            setTip({open:true, severity:"error", msg: t("modify error")});
        }
    }

    const handleSearchDistributor = (v) => {
        if (refTimerDistributorSearcher.current != null) {
            clearTimeout(refTimerDistributorSearcher.current);
        }
        refDistributorSearchValue.current = v;

        refTimerDistributorSearcher.current = setTimeout(async () => {
            const resp = await http.post("distributor/name/list", {
                Value: encodeURIComponent(v),
            }).then(async(r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refDistributorSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({open:true, severity:"error", msg:(resp && resp.msg) ? resp.msg : t("load distributor list error")});
                    return;
                }

                const ls = resp.data.map(({Name, ID}) => {
                    return (
                        <Select.Option key={ID} value={ID}>{Name}</Select.Option>
                    );
                });
                setDistributorSelectOptions(ls);
            } catch(e) {
                console.log("[DeviceAdd]", e);

                setTip({open:true, severity:"error", msg: t("load distributor list error")});
            }
        }, 300);
    }

    const handleSearchTimezone = (v) => {
        if (refTimerTimezoneSearcher.current != null) {
            clearTimeout(refTimerTimezoneSearcher.current);
        }
        refTimezoneSearchValue.current = v;


        refTimerTimezoneSearcher.current = setTimeout(async () => {
            const resp = await http.post("timezone/list", {
                Timezone: encodeURIComponent(v),
            }).then(async (r) => {
                return await r.json();
            }).catch((e) => {
                console.log("[DeviceAdd]", e);
                return null;
            });

            if (refTimezoneSearchValue.current !== v) {
                return;
            }

            try {
                if (resp.code !== 200) {
                    setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("load timezone list error") });
                    return;
                }

                const ls = resp.data.map(({ ZoneName, GmtOffset }) => {
                    var n = parseInt(GmtOffset);
                    var tz = "UTC+";
                    if (n < 0) {
                        tz = "UTC-";
                        n = Math.abs(n);
                    }
                    tz += Math.floor(n / 3600).toString().padStart(2, "0") + ":" + Math.floor((n % 3600) / 60).toString().padStart(2, "0")
                    return (
                        <Select.Option key={ZoneName} value={ZoneName}>{ZoneName}({tz})</Select.Option>
                    );
                });
                setTimezoneSelectOptions(ls);
            } catch (e) {
                console.log("[Device-Adder]", e);

                setTip({ open: true, severity: "error", msg: t("load device list error") });
            }
        }, 300);
    }

    return (<Modal 
        title={t("Modify Distributor User")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={500}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button 
                key="Clear" 
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={params}
        >
            <Input.Group compact>
                <Button><span style={{color: 'red', verticalAlign: 'middle', marginRight: '5px'}}>*</span>{t("Distributor")}</Button>
                <Form.Item 
                    name="DistributorID"
                    label=""
                    rules={[{ required: true }]}
                    style={{width: 'calc(100% - 108px'}}
                >
                    <Select 
                        showSearch
                        placeholder={t("Enter Distributor Name")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchDistributor}
                    >{distributorSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Form.Item 
                name="Name"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Title")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="ID"
                label=""
                rules={[{ required: true, min: 3 }]}
            >
                <Input prefix={<InputPrefix label={t("UserID")} required />} style={{ borderRadius: '20px' }} disabled />
            </Form.Item>
            <Form.Item 
                name="Phone"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Phone")} />} placeholder={t("Phone Number")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="EMail"
                label=""
            >
                <Input prefix={<InputPrefix label={t("E-Mail")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item 
                name="Address"
                label=""
            >
                <Input prefix={<InputPrefix label={t("Address")} />} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Input.Group compact>
                <Button><span style={{color: 'red', verticalAlign: 'middle', marginRight: '5px'}}>*</span>{t("Timezone")}</Button>
                <Form.Item 
                    name="Timezone"
                    label=""
                    style={{width: 'calc(100% - 102px'}}
                    rules={[{ required: true, type: 'string' }]}
                >
                    <Select
                        showSearch
                        placeholder={t("Timezone")}
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={handleSearchTimezone}
                    >{timezoneSelectOptions}</Select>
                </Form.Item>
            </Input.Group>
            <Form.Item 
                name="Enabled"
                label={t("Enabled")}
                valuePropName="checked"
            >
                <Switch />
            </Form.Item>
        </Form>
    </Modal>);
}

export default DistributorUserModifier;